import { createFileRoute } from "@tanstack/react-router";
import StartLanding from "@/pages/StartLanding";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/start/")({
  head: () => routeHead("/start/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <StartLanding />
  );
}
